/* cod-popup.js — Celiati
   - Robust init (desktop + mobile sections)
   - Size/Color from radios OR selects
   - Variant image switch (no clicks → no zoom)
   - Pack discount only for CURRENT product
   - Discount code validate (Apps Script)
   - Shipping rates loader
   - Pixels (FB / TikTok)
   - Optional upsell + final summary
*/

document.addEventListener('DOMContentLoaded', () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // CONFIG / INJECTED
  // ─────────────────────────────────────────────────────────────────────────────
  const WEB_APP_URL = 'https://script.google.com/macros/s/AKfycbxtP1tsURn8NTVHR9luumf-bzDw6k-ol8Tdkk4VwoZ8_L3W6PMisf1kP5QH5h2HP4h2/exec';
  const clientId    = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);

  const ENABLE_UPSELL = (window.ENABLE_UPSELL !== undefined)
    ? !!window.ENABLE_UPSELL
    : false;

  const productTitle = window.codProductTitle || '';
  const countryCode  = window.customerCountryCode || 'MA';
  const countryName  = window.customerCountryName || 'Morocco';

  // Currency symbol (fallback MAD)
  const currencySymbol = (() => {
    if (typeof window.currencySymbol === 'string' && window.currencySymbol.trim()) {
      return window.currencySymbol.trim();
    }
    const el = document.querySelector('.price .money, .product__info-container .price .price-item, .money');
    const txt = el ? el.textContent.trim() : '';
    const m = txt.match(/^[^\d]+/);
    return (m && m[0]) || 'MAD';
  })();

  // Discount codes we already applied/validated in this popup session
  const appliedDiscountCodes = new Set();

  // Pack-discount flags (global image swap state)
  let imageEverSwitched = false;
  let imageLocked       = false;

  // ─────────────────────────────────────────────────────────────────────────────
  // DOM refs (late init — mobile PDP may inject later)
  // ─────────────────────────────────────────────────────────────────────────────
  let openBtn, modal, closeBtn, backdrop, form, variantsList, shipOptsEl,
      subtotalEl, shippingEl, totalEl, confirmBtn, discountInput, applyBtn,
      discountLine, discountAmt;

  function setDomRefs() {
    openBtn      = document.getElementById('cod-open-button');
    modal        = document.getElementById('cod-modal');
    closeBtn     = document.getElementById('cod-close-button');
    form         = document.getElementById('cod-form');
    variantsList = document.getElementById('cod-variants-list');
    shipOptsEl   = document.getElementById('cod-shipping-options');
    subtotalEl   = document.getElementById('cod-subtotal');
    shippingEl   = document.getElementById('cod-shipping-fee');
    totalEl      = document.getElementById('cod-total');
    confirmBtn   = document.getElementById('cod-confirm');
    discountInput= document.getElementById('cod-discount');
    applyBtn     = document.getElementById('cod-apply-discount');
    discountLine = document.getElementById('cod-discount-line');
    discountAmt  = document.getElementById('cod-discount-amount');
    backdrop     = modal ? modal.querySelector('.cod-modal__backdrop') : null;
  }
  setDomRefs();

  // ─────────────────────────────────────────────────────────────────────────────
  // Shopify data
  // ─────────────────────────────────────────────────────────────────────────────
  const productVariants = JSON.parse(
    document.getElementById('product-variants-json')?.textContent || '[]'
  );
  const currentProductId = Number(
    window.currentProductId || window.productId || (productVariants[0]?.product_id) || 0
  );

function getMetaContentId(variant) {
  return String(variant.id);
}

function setActiveVariantId(variantId) {
  // Update all product forms hidden id inputs so Shopify/Dawn logic stays consistent
  document.querySelectorAll('input[name="id"]').forEach((el) => {
    el.value = String(variantId);
    el.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Update URL so you get ?variant=... again (helps tracking/debug + sharing)
  try {
    const base = window.location.pathname;
    window.history.replaceState({}, '', `${base}?variant=${variantId}`);
  } catch (e) {}
}

  // merged list shown in popup (cart + new selections)
  let mergedVariants = [];

  // ─────────────────────────────────────────────────────────────────────────────
  // Helpers — options
  // ─────────────────────────────────────────────────────────────────────────────
  function getSelectedSize() {
    const r = document.querySelector('input[name="size"]:checked');
    if (r?.value) return r.value;

    const sizeSel =
      document.querySelector('select[name*="Size" i], select[name*="Taille" i]') ||
      document.querySelector('select[name="options[Size]"], select[name="options[Taille]"]');

    if (sizeSel?.value) return sizeSel.value;

    const allOpts = document.querySelectorAll('select[name^="options"]');
    if (allOpts.length >= 1 && allOpts[0].value) return allOpts[0].value;

    return '';
  }

  function getSelectedColors() {
    const sw = Array.from(document.querySelectorAll('.color-swatch-input:checked')).map(el => el.value);
    if (sw.length) return sw;

    const colorSel =
      document.querySelector('select[name*="Color" i], select[name*="Couleur" i]') ||
      document.querySelector('select[name="options[Color]"], select[name="options[Couleur]"]');

    if (colorSel?.value) return [colorSel.value];

    const allOpts = document.querySelectorAll('select[name^="options"]');
    if (allOpts.length >= 2 && allOpts[1].value) return [allOpts[1].value];

    return [];
  }

  function findVariantBySizeColor(size, color) {
    if (!size || !color) return null;
    return productVariants.find(v =>
      (v.option1 === size && v.option2 === color) ||
      (v.option2 === size && v.option1 === color)
    );
  }

  function getSelectedVariants() {
    const size   = getSelectedSize();
    const colors = getSelectedColors();
    return productVariants.filter(v =>
      colors.some(color =>
        (v.option1 === size && v.option2 === color) ||
        (v.option2 === size && v.option1 === color)
      )
    );
  }

  // keep colors valid for chosen size (auto-pick first available color)
  function enforceValidColorsForSelectedSize() {
    const size = getSelectedSize();
    if (!size) return;

    const colorInputs = Array.from(document.querySelectorAll('.color-swatch-input'));
    if (!colorInputs.length) return;

    let anyChecked = false;

    colorInputs.forEach(input => {
      const color = input.value;
      const v = findVariantBySizeColor(size, color);
      const canUse = !!v && v.available;

      input.disabled = !canUse;
      input.closest('label')?.classList.toggle('is-disabled', !canUse);
      if (input.checked && !canUse) input.checked = false;
      if (input.checked) anyChecked = true;
    });

    if (!anyChecked) {
      const firstAvail = colorInputs.find(input => {
        const v = findVariantBySizeColor(size, input.value);
        return v && v.available;
      });
      if (firstAvail) firstAvail.checked = true;
    }
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // Helpers — media switching (no clicks → no zoom)
  // ─────────────────────────────────────────────────────────────────────────────
  function normalizeFile(url) {
    return (url || '')
      .split('?')[0]
      .replace(/_(\d+x\d+|{width}x)\./, '.')
      .split('/')
      .pop();
  }

  function fileStem(url) {
  let f = (url || '').split('?')[0];                  // drop query
  f = f.split('/').pop();                             // basename
  f = f.replace(/_(\d+x\d+|{width}x)\./i, '.');       // drop _600x., _{width}x.
  f = f.toLowerCase().replace(/\.(avif|webp|jpe?g|png|gif|bmp|heic|heif)$/i, ''); // drop ext
  return f;
}

function pickFromSrcset(srcset) {
  if (!srcset) return '';
  const parts = String(srcset).split(',').map(s => s.trim()).filter(Boolean);
  if (!parts.length) return '';
  // prefer the last (usually largest) candidate
  const last = parts[parts.length - 1].split(/\s+/)[0];
  return last || '';
}

// Get the best-guess file stem from an <img> (handles lazy data-* attrs)
function imgCandidateStem(img) {
  if (!img) return '';
  const url =
    img.currentSrc ||
    pickFromSrcset(img.getAttribute('srcset')) ||
    img.getAttribute('src') ||
    pickFromSrcset(img.getAttribute('data-srcset')) ||
    img.getAttribute('data-src') ||
    '';
  return fileStem(url);
}

  function getHeroImg() {
  const candidates = Array.from(document.querySelectorAll([
    // mobile sliders first
    'slider-component .slider__slide[aria-hidden="false"] img',
    'slider-component .slider__slide:not([hidden]) img',
    '.flickity-enabled .is-selected img',
    '.swiper-slide-active img',
    // general fallbacks
    '[data-product-media] img',
    '.product__media img',
    '.product-gallery img',
    'main .product img',
    'main img'
  ].join(','))).filter(img => img.offsetWidth && img.offsetHeight);

  let best = null, bestArea = 0;
  for (const img of candidates) {
    const r = img.getBoundingClientRect();
    const area = r.width * r.height;
    if (area > bestArea && area > 150 * 150) { best = img; bestArea = area; }
  }
  return best;
}

function getComputedBgUrl(el) {
  const bg = el ? getComputedStyle(el).backgroundImage : '';
  if (!bg || bg === 'none') return '';
  const m = bg.match(/url\(["']?(.+?)["']?\)/i);
  return m ? m[1] : '';
}

function getHeroBgNode() {
  const nodes = Array.from(document.querySelectorAll([
    '.product__media',
    '[data-product-media]',
    'slider-component .slider__slide[aria-hidden="false"]',
    '.flickity-enabled .is-selected',
    '.swiper-slide-active',
    '.product-gallery',
    'main .product',
    'main'
  ].join(','))).filter(n => {
    const r = n.getBoundingClientRect();
    return r.width > 150 && r.height > 150 && !!getComputedBgUrl(n);
  });

  // pick the largest background node with an image
  let best = null, bestArea = 0;
  for (const n of nodes) {
    const r = n.getBoundingClientRect();
    const area = r.width * r.height;
    if (area > bestArea) { best = n; bestArea = area; }
  }
  return best;
}

// Replace the visible hero with a plain <img>, or set bg-image, no zoom/lightbox.
function hardSwapHeroImage(url) {
  if (!url) return;

  const heroImg = getHeroImg();
  if (heroImg) {
    // Replace the <picture> (or <img>) with a fresh <img src=url>
    const host = heroImg.closest('picture') || heroImg;
    const newImg = document.createElement('img');
    newImg.className = heroImg.className || '';
    newImg.alt = heroImg.alt || '';
    newImg.style.cssText = heroImg.style.cssText || '';
    newImg.src = url;            // only src; no srcset/sizes → no AVIF/WEBP conflicts
    newImg.loading = 'eager';
    newImg.decoding = 'sync';
    host.replaceWith(newImg);
    return;
  }

  const bg = getHeroBgNode();
  if (bg) {
    bg.style.backgroundImage = `url("${url}")`;
  }
}

// Find a visible gallery slide whose <img> or background-image matches `file`
function findSlideByImageFile(targetStem) {
  if (!targetStem) return null;
  const slideSelectors = [
    'slider-component .slider__slide',
    '.flickity-enabled .carousel-cell',
    '.swiper-wrapper .swiper-slide',
    '[data-product-media]',
    '.product__media',
    '.product-gallery [data-media-id]'
  ];
  const slides = document.querySelectorAll(slideSelectors.join(','));
  for (const s of slides) {
    const img  = s.querySelector('img');
    let stem = imgCandidateStem(img);
    if (!stem) stem = fileStem(getComputedBgUrl(s));
    if (stem && stem === targetStem) return s;
  }
  return null;
}

// Click a thumbnail whose <img> file matches `file`.
// Works even when there is no data-media-id / hash on the control.
function clickThumbByImageFile(targetStem) {
  if (!targetStem) return false;
  const thumbImgSelectors = [
    '.thumbnail-list img',
    '[id^="Slider-Thumbnails-"] img',
    '.thumbnails img',
    '[data-thumbnails] img',
    '.product__media-thumbnails img',
    '.product-media__thumbnails img'
  ];
  const imgs = document.querySelectorAll(thumbImgSelectors.join(','));
  for (const img of imgs) {
    const stem = imgCandidateStem(img);
    if (stem === targetStem) {
      let btn = img.closest('button, [role="button"], a[href^="#"], [data-thumbnail]');
      if (!btn && img.parentElement) btn = img.parentElement; // some themes wrap img directly
      if (btn) {
        btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        return true;
      }
    }
  }
  return false;
}

  function currentMainImageFile() {
  const img = getHeroImg();
  if (img) return normalizeFile(img.currentSrc || img.src);

  const bg = getHeroBgNode();
  if (bg) return normalizeFile(getComputedBgUrl(bg));

  return '';
}

function currentHeroStem() {
  const img = getHeroImg();
  if (img) return imgCandidateStem(img);
  const bg  = getHeroBgNode();
  if (bg)   return fileStem(getComputedBgUrl(bg));
  return '';
}

  function variantImageUrl(v) {
    return v?.featured_media?.preview_image?.src
        || v?.featured_media?.src
        || v?.featured_image?.src
        || v?.image
        || '';
  }

  function variantMediaId(v) {
  return v?.featured_media?.id
      || v?.featured_image?.id
      || v?.image_id
      || null;
}

  function switchToVariantImage(variant) {
  if (!variant) return;

  const wantUrl = variantImageUrl(variant);
  if (!wantUrl) return;

  // Compare by stem so .jpg/.webp/.avif all match the same image
  const wantStem = fileStem(wantUrl);
  const curStem  = currentHeroStem();

  // 1) Try the theme API (Dawn v7+)
  const mId = variantMediaId(variant);
  if (mId) {
    const mg = document.querySelector('media-gallery');
    if (mg && typeof mg.setActiveMedia === 'function') {
      try { mg.setActiveMedia(String(mId), true); return; } catch (e) {}
    }

    // 2) Try to click a REAL thumbnail/control (never the hero)
    const thumbRoots = [
      '.thumbnail-list',
      '[id^="Slider-Thumbnails-"]',
      '.thumbnails',
      '[data-thumbnails]',
      '.product__media-thumbnails',
      '.product-media__thumbnails'
    ].map(s => document.querySelector(s)).filter(Boolean);

    const scopeList = thumbRoots.length ? thumbRoots : [document];
    let control = null;

    for (const scope of scopeList) {
      // Prefer buttons / role=button / dedicated thumbnail elements
      control =
        scope.querySelector(`[data-media-id="${mId}"] button`) ||
        scope.querySelector(`[data-media-id="${mId}"][role="button"]`) ||
        scope.querySelector(`[data-thumbnail][data-media-id="${mId}"]`);

      // Hash anchors that only move the slider (don’t open lightbox)
      if (!control) {
        control =
          scope.querySelector(`a[href^="#MediaGallery-${mId}"]`) ||
          scope.querySelector(`a[href^="#Slide-${mId}"]`) ||
          scope.querySelector(`a[data-media-id="${mId}"][href^="#"]`);
      }
      if (control) break;
    }

    if (control) {
      if (control.tagName.toLowerCase() === 'img') {
        const container = control.closest('button, [role="button"], a[href^="#"]');
        if (container) control = container;
      }
      control.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      return;
    }
  }

  // 2b) No control with a media-id? Click a thumbnail by matching the image file stem
  if (clickThumbByImageFile(wantStem)) return;

  // 3) No control to click? Do NOT call scrollIntoView here. That would move
  // the shopper away from the color selector / Buy Now area. If Dawn exposes no
  // usable media control, keep the current gallery position rather than moving
  // the entire page.

  // 4) Nothing else to do — we avoid manual <picture>/<img> rewrites (those caused the blank hero)
}

  // ─────────────────────────────────────────────────────────────────────────────
  // Pack discount — ONLY for this product_id
  // ─────────────────────────────────────────────────────────────────────────────
  function qtyForCurrentProduct(list) {
    if (!currentProductId) return 0;
    return list.reduce((sum, v) => {
      return sum + (Number(v.product_id) === currentProductId ? (v.quantity || 1) : 0);
    }, 0);
  }

  function packRateForCurrent(list) {
    if (window.isPackOffer !== true) return 0; // metafield flag
    const qty = qtyForCurrentProduct(list);
    if (qty >= 3) return 0.10;
    if (qty === 2) return 0.05;
    return 0;
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // Cart / Popup rendering
  // ─────────────────────────────────────────────────────────────────────────────
  async function getCartItems() {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      return data.items.map(item => {
        const variantData = productVariants.find(v => v.id === item.variant_id);
        return {
          product_id:    item.product_id,
          variant_id:    item.variant_id,
          quantity:      item.quantity,
          price:         variantData ? (parseFloat(variantData.price) / 100)
                                     : (parseFloat(item.final_price) / 100),
          title:         window.translationsByProductId?.[item.product_id] || item.product_title,
          variant_title: variantData
            ? `${variantData.option1 || ''} / ${variantData.option2 || ''}`
            : (item.variant_title || ''),
          imgSrc:        variantData?.featured_image?.src || item.image || ''
        };
      });
    } catch (err) {
      console.error('Failed to fetch cart items:', err);
      return [];
    }
  }

  function updateVariantDisplay(list) {
    if (!variantsList) return;
    variantsList.innerHTML = list.map(v => {
      const price = parseFloat(v.price) || 0;
      let discounted = price;

      const rate = packRateForCurrent(list);
      if (rate > 0 && Number(v.product_id) === currentProductId) {
        discounted = price * (1 - rate);
      }
      const qty = v.quantity || 1;

      return `
        <div class="cod-variant-item" data-variant-id="${v.variant_id}">
          <div style="position: relative; display: inline-block;">
            <img src="${v.imgSrc || ''}" width="40" alt="" style="border-radius:4px;" />
            ${qty > 1
              ? `<span style="position:absolute;top:-8px;left:-8px;background:#000;color:#fff;font-size:12px;font-weight:bold;padding:2px 5px;border-radius:10px;z-index:1;">${qty}</span>`
              : ''
            }
          </div>
          <div class="cod-variant-details">
            <div class="cod-variant-header">
              <span class="cod-product-title">${v.title || ''}</span>
              <span class="cod-variant-price">${currencySymbol} ${(discounted).toFixed(2)}</span>
            </div>
            <div class="cod-variant-text">${v.variant_title || ''}</div>
          </div>
          <button type="button" class="cod-remove-variant" data-variant-id="${v.variant_id}">×</button>
        </div>`;
    }).join('');
  }

  function updatePrices(list) {
  if (!subtotalEl || !shippingEl || !totalEl) return;

  const subtotal = list.reduce((sum, v) => {
    return sum + ((parseFloat(v.price) || 0) * (v.quantity || 1));
  }, 0);

  // PACK DISCOUNT
  const rate = packRateForCurrent(list);

  const packBase = list.reduce((sum, v) => {
    if (Number(v.product_id) === currentProductId) {
      return sum + ((parseFloat(v.price) || 0) * (v.quantity || 1));
    }
    return sum;
  }, 0);

  const discountAmount = packBase * rate;
  const discountedSubtotal = subtotal - discountAmount;

  // SHOW DISCOUNT
  if (discountLine && discountAmt) {
    if (discountAmount > 0) {
      discountLine.style.display = 'flex';
      discountAmt.textContent =
        '− ' + currencySymbol + discountAmount.toFixed(2);
    } else {
      discountLine.style.display = 'none';
      discountAmt.textContent = '';
    }
  }

  // FREE SHIPPING RULE
  const FREE_SHIPPING_THRESHOLD = 500;

  let shipping = 0;

  const selectedShipping =
    document.querySelector('input[name="cod-shipping"]:checked');

  const shippingLabels =
    document.querySelectorAll('input[name="cod-shipping"]');

  // FREE SHIPPING
  if (discountedSubtotal >= FREE_SHIPPING_THRESHOLD) {
    shipping = 0;

    shippingLabels.forEach(input => {
      input.value = '0';

      const priceEl =
        input.closest('.cod-shipping-option')
          ?.querySelector('span:last-child');

      if (priceEl) {
        priceEl.textContent = currencySymbol + ' 0.00';
      }
    });

  } else {

    // RESTORE NORMAL SHIPPING
    shippingLabels.forEach(input => {

      const title =
        (input.dataset.title || '').toLowerCase();

      let normalPrice = 29;

      if (
        title.includes('rabat') ||
        title.includes('salé') ||
        title.includes('sale')
      ) {
        normalPrice = 20;
      }

      input.value = normalPrice.toFixed(2);

      const priceEl =
        input.closest('.cod-shipping-option')
          ?.querySelector('span:last-child');

      if (priceEl) {
        priceEl.textContent =
          currencySymbol + ' ' + normalPrice.toFixed(2);
      }
    });

    shipping =
      parseFloat(
        document.querySelector('input[name="cod-shipping"]:checked')?.value || 0
      );
  }

  subtotalEl.textContent =
    `${currencySymbol} ${discountedSubtotal.toFixed(2)}`;

  shippingEl.textContent =
    `${currencySymbol} ${shipping.toFixed(2)}`;

  totalEl.textContent =
    `${currencySymbol} ${(discountedSubtotal + shipping).toFixed(2)}`;
}

  // ─────────────────────────────────────────────────────────────────────────────
  // Shipping rates
  // ─────────────────────────────────────────────────────────────────────────────
  let shippingRates = [];
  async function loadShippingRates() {
    try {
      const res = await fetch(
        `/cart/shipping_rates.json?shipping_address[country]=${countryCode}`,
        { credentials: 'same-origin' }
      );
      const json = await res.json();
      shippingRates = json.shipping_rates || [];
      if (shipOptsEl) {
        shipOptsEl.innerHTML = shippingRates.map((r, i) => {
          const title = r.title || r.name || r.handle || 'Shipping';
          const price = parseFloat(r.price).toFixed(2);
          return `
            <label class="cod-shipping-option">
              <input type="radio" name="cod-shipping" value="${price}"
                     data-title="${title}" ${i===0?'checked':''} />
              <span>${title}</span>
              <span>${currencySymbol} ${price}</span>
            </label>`;
        }).join('');
      }
      refreshContent();
    } catch (err) {
      console.error('Failed to load shipping rates', err);
    }
  }

  // Temporarily suppress small fixed bottom-right widgets (e.g. WhatsApp)
  // while the COD checkout is open. This intentionally runs only AFTER the
  // selected variants have already been read, so it cannot interfere with the
  // product/variant or shipping logic.
  const __codSuppressedFloaters = new Map();
  let __codFloaterObserver = null;
  let __codFloaterTimer = null;

  function suppressExternalFloatingWidgets() {
    if (!modal || modal.classList.contains('hidden')) return;

    const viewportW = window.innerWidth || document.documentElement.clientWidth;
    const viewportH = window.innerHeight || document.documentElement.clientHeight;

    document.querySelectorAll('body *').forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      if (el === modal || modal.contains(el)) return;
      if (__codSuppressedFloaters.has(el)) return;

      const style = window.getComputedStyle(el);
      if (style.position !== 'fixed') return;

      const rect = el.getBoundingClientRect();
      if (rect.width < 34 || rect.height < 34 || rect.width > 180 || rect.height > 180) return;

      // Only target compact floating controls that live in the lower-right
      // corner. This avoids touching sticky product buttons or page content.
      const inBottomRight =
        rect.right >= viewportW - 185 &&
        rect.bottom >= viewportH - 185 &&
        rect.left >= viewportW - 220;

      if (!inBottomRight) return;

      __codSuppressedFloaters.set(el, {
        visibility: el.style.getPropertyValue('visibility'),
        visibilityPriority: el.style.getPropertyPriority('visibility'),
        pointerEvents: el.style.getPropertyValue('pointer-events'),
        pointerEventsPriority: el.style.getPropertyPriority('pointer-events'),
        opacity: el.style.getPropertyValue('opacity'),
        opacityPriority: el.style.getPropertyPriority('opacity'),
      });

      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('opacity', '0', 'important');
      el.dataset.codTemporarilyHidden = '1';
    });
  }

  function startFloatingWidgetSuppression() {
    suppressExternalFloatingWidgets();

    if (__codFloaterObserver) return;
    __codFloaterObserver = new MutationObserver(() => {
      clearTimeout(__codFloaterTimer);
      __codFloaterTimer = setTimeout(suppressExternalFloatingWidgets, 80);
    });
    __codFloaterObserver.observe(document.body, { childList: true, subtree: true });

    // Some chat apps reposition/recreate their button after animations.
    setTimeout(suppressExternalFloatingWidgets, 250);
    setTimeout(suppressExternalFloatingWidgets, 800);
  }

  function restoreExternalFloatingWidgets() {
    if (__codFloaterObserver) {
      __codFloaterObserver.disconnect();
      __codFloaterObserver = null;
    }
    clearTimeout(__codFloaterTimer);

    __codSuppressedFloaters.forEach((prev, el) => {
      if (!el || !el.style) return;

      const restore = (prop, value, priority) => {
        if (value) el.style.setProperty(prop, value, priority || '');
        else el.style.removeProperty(prop);
      };

      restore('visibility', prev.visibility, prev.visibilityPriority);
      restore('pointer-events', prev.pointerEvents, prev.pointerEventsPriority);
      restore('opacity', prev.opacity, prev.opacityPriority);
      delete el.dataset.codTemporarilyHidden;
    });
    __codSuppressedFloaters.clear();
  }

  function closeModal() {
    modal?.classList.add('hidden');
    document.body.classList.remove('cod-modal-open');
    restoreExternalFloatingWidgets();
    const mainEl = document.querySelector('main');
    if (mainEl?.style) mainEl.style.filter = '';

    // Restore the CTA if the modal is closed after an interrupted attempt.
    if (confirmBtn) {
      confirmBtn.removeAttribute('aria-busy');
      if (!confirmBtn.dataset.orderCompleted) {
        confirmBtn.disabled = false;
        confirmBtn.innerHTML = 'Confirmer la commande';
      }
    }
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // Core refresh (image swap + popup list + button state)
  // ─────────────────────────────────────────────────────────────────────────────
  async function refreshContent() {
    enforceValidColorsForSelectedSize();

    const size       = getSelectedSize();
    const colors     = getSelectedColors();
    const colorCount = colors.length;

    if (colorCount === 1) imageLocked = false;

    if (size && colorCount === 1 && !imageLocked) {
  const v = findVariantBySizeColor(size, colors[0]);
  if (v) {
    // Preserve the shopper's exact viewport while the product gallery updates.
    // Some Dawn media controls/anchors otherwise pull the page back to the hero.
    const keepX = window.scrollX || window.pageXOffset || 0;
    const keepY = window.scrollY || window.pageYOffset || 0;
    const restoreViewport = () => {
      if (Math.abs((window.scrollY || window.pageYOffset || 0) - keepY) > 1 ||
          Math.abs((window.scrollX || window.pageXOffset || 0) - keepX) > 1) {
        window.scrollTo(keepX, keepY);
      }
    };

    switchToVariantImage(v);
    restoreViewport();
    requestAnimationFrame(restoreViewport);
    setTimeout(restoreViewport, 40);
    setTimeout(restoreViewport, 140);

    imageEverSwitched = true;

    // ✅ Keep Shopify/Dawn in sync (variant id + URL)
    setActiveVariantId(v.id);

    // Meta ViewContent is intentionally handled by Shopify's official
    // Facebook & Instagram channel to avoid duplicate browser events.
  }
}


    if (colorCount > 1 && imageEverSwitched) imageLocked = true;

    // Build the popup list: CART + (selected variants will be added when opening)
    const cartItems = await getCartItems();
    const combined  = [...cartItems];

    // merge same variant_id for display
    const mergedMap = new Map();
    for (const item of combined) {
      if (mergedMap.has(item.variant_id)) {
        mergedMap.get(item.variant_id).quantity += item.quantity;
      } else {
        mergedMap.set(item.variant_id, { ...item });
      }
    }
    mergedVariants = Array.from(mergedMap.values());

    updateVariantDisplay(mergedVariants);
    updatePrices(mergedVariants);

    // Button state
    const selected = getSelectedVariants();
    const isOutOfStock = selected.length === 0 || selected.some(v => !v.available);
    if (openBtn) {
      if (isOutOfStock) {
        openBtn.disabled = true;
        openBtn.textContent = 'Épuisé';
        openBtn.classList.add('cod-btn-disabled');
      } else {
        openBtn.disabled = false;
        openBtn.textContent = '🛒 Commander maintenant';
        openBtn.classList.remove('cod-btn-disabled');
      }
    }
  }

  // --- Mobile-only: watch the hidden variant id input and swap hero image ---
let __variantWatchTimer = null;

function startVariantWatch() {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  if (!isMobile) return;
  if (__variantWatchTimer) return; // already running

  // Seed lastId with the current variant id (prevents a first "fake" swap)
  const seedEl =
    document.querySelector('form[action^="/cart/add"] input[name="id"]') ||
    document.querySelector('form[action="/cart/add"] input[name="id"]')  ||
    document.querySelector('form[id*="product"] input[name="id"]')       ||
    document.querySelector('input[name="id"][form]');
  let lastId = seedEl ? Number(seedEl.value || seedEl.getAttribute('value')) : null;

  __variantWatchTimer = setInterval(() => {
  const idEls = Array.from(document.querySelectorAll('input[name="id"]'));
  const currId = idEls.map(el => Number(el.value || el.getAttribute('value'))).find(n => !!n) || null;
  if (!currId || currId === lastId) return;

  lastId = currId;

  const v = productVariants.find(x => x.id === currId);
  if (v) {
    switchToVariantImage(v);
    imageEverSwitched = true;
    imageLocked = false;
  }
}, 400);
}


  // ─────────────────────────────────────────────────────────────────────────────
  // Wiring (safe, once elements exist)
  // ─────────────────────────────────────────────────────────────────────────────
  function wireListenersOnce() {
    if (openBtn?.dataset.codWired === '1') return;

    // Open modal → add all selected variants in one batch
    openBtn?.addEventListener('click', () => {
      const mainEl = document.querySelector('main');
      if (mainEl?.style) mainEl.style.filter = 'blur(5px)';
      modal?.classList.remove('hidden');
      document.body.classList.add('cod-modal-open');

      const selectedVariants = getSelectedVariants();

      // Hide external floating chat controls only after variant selection has
      // been captured. The checkout data flow remains untouched.
      startFloatingWidgetSuppression();

      // Meta tracking for the custom COD funnel:
      // - AddToCart is NOT fired manually here. The real /cart/add.js request
      //   below is observed by Shopify's official Facebook & Instagram channel.
      // - InitiateCheckout remains manual because this COD modal does not enter
      //   Shopify's native checkout flow.
      try {
        if (typeof fbq !== 'undefined' && selectedVariants.length > 0) {
          const contents = selectedVariants.map(v => ({
            id: getMetaContentId(v),
            quantity: 1,
            item_price: Number(v.price) ? Number(v.price) / 100 : 0,
          }));

          const totalValue = contents.reduce(
            (s, c) => s + (c.item_price || 0) * (c.quantity || 1),
            0
          );

          // Prevent accidental rapid double-clicks from creating two checkout events.
          const now = Date.now();
          if (!window.__celiatiInitiateCheckoutTs || (now - window.__celiatiInitiateCheckoutTs) > 1500) {
            window.__celiatiInitiateCheckoutTs = now;

            fbq('track', 'InitiateCheckout', {
              content_ids: contents.map(c => c.id),
              content_type: 'product',
              value: totalValue,
              currency: 'MAD',
              contents,
            });
          }
        }
      } catch (e) {
        console.warn('Meta COD InitiateCheckout tracking failed:', e);
      }


      if (selectedVariants.length > 0) {
        const itemsToAdd = selectedVariants.map(v => ({ id: v.id, quantity: 1 }));
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        })
        .then(r => (r.ok ? r.json() : Promise.reject('Add to cart failed')))
        .then(() => loadShippingRates())
        .catch(err => console.error('Error adding variants:', err));
      } else {
        // still load shipping, then compute prices
        loadShippingRates();
      }
    });

    closeBtn?.addEventListener('click', closeModal);
    backdrop?.addEventListener('click', closeModal);

    // Some themes emit custom events on variant changes / section loads
document.addEventListener('variant:change', refreshContent, true);
document.addEventListener('product:variant-change', refreshContent, true);
document.addEventListener('shopify:section:load', refreshContent, true);

// Input event helps when mobile selects update value before 'change' fires
document.addEventListener('input', (e) => {
  const t = e.target;
  if (
    t.matches('select[name^="options"]') ||
    t.matches('select[name*="Color" i]') ||
    t.matches('select[name*="Taille" i]')
  ) {
    refreshContent();
  }
});


    // Size/Color changes (radios + selects)
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (
        t.matches('input[name="size"]') ||
        t.matches('.color-swatch-input') ||
        t.matches('select[name^="options"]') ||
        t.matches('select[name*="Color" i]') ||
        t.matches('select[name*="Taille" i]')
      ) {
        refreshContent();
      }
    });

    // Remove variant (inside popup)
if (variantsList) {
  variantsList.addEventListener('click', function(e) {
    var btn = e.target.closest('.cod-remove-variant');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var vid = Number(btn.getAttribute('data-variant-id'));

    // 1) Remove immediately from modal display
    mergedVariants = mergedVariants.filter(function(v) {
      return Number(v.variant_id) !== vid;
    });

    updateVariantDisplay(mergedVariants);
    updatePrices(mergedVariants);

    // 2) Update Shopify cart
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: String(vid),
        quantity: 0
      })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart change failed');
      return res.json();
    })
    .then(function() {
      // 3) Reload shipping rates after cart subtotal changes
      return loadShippingRates();
    })
    .catch(function(err) {
      console.error('Remove variant failed:', err);
      updateVariantDisplay(mergedVariants);
      updatePrices(mergedVariants);
    });
  });
}

    // Update order summary when shipping option changes
if (shipOptsEl) {
  shipOptsEl.addEventListener('change', function(e) {
    var target = e.target;
    if (target && target.matches('input[name="cod-shipping"]')) {
      updatePrices(mergedVariants);
    }
  });
}

    // Validate & apply discount (popup)
    applyBtn?.addEventListener('click', async () => {
      const code = discountInput.value.trim();
      if (!code) { alert('Veuillez entrer un code promo.'); return; }
      if (appliedDiscountCodes.has(code.toLowerCase())) {
        alert('Ce code a déjà été utilisé dans cette commande.'); return;
      }

      applyBtn.disabled = true;
      applyBtn.textContent = 'Vérification…';

      const line_items = mergedVariants.map(v => ({
        variant_id:    v.variant_id,
        quantity:      v.quantity,
        price:         parseFloat(v.price).toFixed(2),
        title:         v.title,
        variant_title: v.variant_title
      }));

      try {
        const res  = await fetch(WEB_APP_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify({ clientId, validateOnly: true, discountCode: code, line_items })
        });
        const json = await res.json();
        if (json.result !== 'ok') {
          alert(`Erreur: ${json.message}\n\n${json.body || ''}`);
          return;
        }
        appliedDiscountCodes.add(code.toLowerCase());

        // Show discount line & recompute totals (json.discountAmount is positive number)
        if (discountLine && discountAmt) {
          discountLine.style.display = 'flex';
          discountAmt.textContent = `${json.discountAmount}`;
        }
        const sub  = parseFloat(subtotalEl.textContent.replace(/[^\d.]/g, '')) || 0;
        const ship = parseFloat(shippingEl.textContent.replace(/[^\d.]/g, '')) || 0;
        const disc = parseFloat(json.discountAmount) || 0;
        const newSub = (sub + disc).toFixed(2);
        subtotalEl.textContent = `${currencySymbol} ${newSub}`;
        totalEl.textContent    = `${currencySymbol} ${(parseFloat(newSub) + ship).toFixed(2)}`;
      } catch (err) {
        console.error(err);
        alert('Code non valide');
      } finally {
        applyBtn.disabled = false;
        applyBtn.textContent = 'Valider';
      }
    });

    // Confirm (place order via Apps Script)
    confirmBtn?.addEventListener('click', async (e) => {
      e.preventDefault();
      if (!form?.checkValidity()) { form?.reportValidity(); return; }
      confirmBtn.disabled = true;
      confirmBtn.setAttribute('aria-busy', 'true');
      confirmBtn.innerHTML = '<span class="cod-btn-spinner" aria-hidden="true"></span><span>Confirmation en cours…</span>';

      // Customer info
      const rawPhone = form.querySelector('#cod-phone')?.value.trim()   || '';
      const rawName  = form.querySelector('#cod-name')?.value.trim()    || '';
      const rawCity  = form.querySelector('#cod-city')?.value.trim()    || '';
      const rawAddr  = form.querySelector('#cod-address')?.value.trim() || '';
      const customer = {
        email:   rawPhone.replace(/\D/g,'') + '@cod.celiati.com',
        name:    rawName,
        phone:   rawPhone,
        city:    rawCity,
        address: rawAddr,
        countryCode, countryName
      };

      // Shipping
      const shipEl = document.querySelector('input[name="cod-shipping"]:checked');
      const shippingFee  = parseFloat(shipEl?.value) || 0;
      const shippingTitle= shipEl?.dataset.title || 'COD';
      const discountCode = discountInput?.value.trim() || '';
      const discountValue= discountCode
        ? (parseFloat(discountAmt?.textContent.replace(/[^0-9.]/g,'') || '0') || 0)
        : 0;

      // Initial items with pack discount for CURRENT product only
      const rate = packRateForCurrent(mergedVariants);
      const initialItems = mergedVariants.map(v => {
        const price = parseFloat(v.price) || 0;
        const use   = (Number(v.product_id) === currentProductId) ? rate : 0;
        const final = (price * (1 - use)).toFixed(2);
        return {
          variant_id:    v.variant_id,
          quantity:      v.quantity,
          price:         final,
          original_price: price,
          title:         v.title,
          variant_title: v.variant_title,
          imgSrc:        v.imgSrc
        };
      });

      try {
        const initPayload = {
          clientId: Date.now().toString(36) + '-' + Math.random().toString(36).slice(2),
          ...customer,
          discountCode,
          discountAmount: discountValue,
          line_items: initialItems,
          shippingFee,
          subtotal: initialItems.reduce((s,i)=> s + (parseFloat(i.price) * (i.quantity||1)), 0),
          total:    initialItems.reduce((s,i)=> s + (parseFloat(i.price) * (i.quantity||1)), 0) - discountValue + shippingFee,
          deliveryTitle: shippingTitle,
          deliveryTag:   'COD'
        };

        const res  = await fetch(WEB_APP_URL, {
          method: 'POST',
          headers: { 'Content-Type':'text/plain' },
          body: JSON.stringify(initPayload)
        });
        const json = await res.json();
        if (json.result === 'backup_saved') {
  alert(json.message || 'Votre demande a bien été enregistrée. Notre équipe vous contactera pour confirmer votre commande..');
  closeModal();
  confirmBtn.removeAttribute('aria-busy');
  confirmBtn.disabled = false;
  confirmBtn.innerHTML = 'Confirmer la commande';
  return;
}

if (json.result === 'error') {
  throw new Error(json.message);
}

const orderStatusUrl = json.order_status_url;

        // Pixels (one-time)
        try {
          const totalValue = initPayload.total;
          const contents = initPayload.line_items.map(item => ({
            id: item.variant_id,
            quantity: item.quantity,
            item_price: parseFloat(item.price)
          }));

          if (typeof fbq !== 'undefined' && !window.__celiatiPurchaseSent) {
            fbq('track', 'Purchase', {
  content_ids: contents.map(c => getMetaContentId({ id: c.id, price: (c.item_price * 100) })), // safe
  content_type: 'product',
  currency: 'MAD',
  value: Number(totalValue) || 0,
  contents,
  num_items: contents.reduce((s,c)=> s + (c.quantity||1), 0),
});

            window.__celiatiPurchaseSent = true;
          }
          if (typeof ttq !== 'undefined') {
            ttq.track('Purchase', {
              currency: 'MAD',
              value: totalValue,
              contents: contents.map(c => ({
                content_id: c.id,
                quantity: c.quantity,
                price: c.item_price
              }))
            });
          }
        } catch (e2) {
          console.warn('Pixel tracking failed:', e2);
        }

        // The order is now created successfully.
        confirmBtn.dataset.orderCompleted = '1';
        confirmBtn.removeAttribute('aria-busy');
        confirmBtn.innerHTML = 'Commande confirmée ✓';

        // Upsell?
        const distinctCount = initialItems.length;
        const totalQty = initialItems.reduce((s,i)=> s + (i.quantity||1), 0);
        const shouldUpsell = ENABLE_UPSELL && (distinctCount === 1 && totalQty === 1);

        if (shouldUpsell) {
          showUpsellModal(initialItems, customer, shippingFee, orderStatusUrl);
        } else {
          showFinalSummaryModal(
            initialItems, [],
            customer, shippingFee,
            discountCode, discountValue,
            '/' // redirect target used by your summary
          );
        }
      } catch (err) {
        console.error('Initial order failed:', err?.message || err);
        alert(`Une erreur est survenue. Veuillez réessayer.\n\n${err?.message || err}`);
        confirmBtn.removeAttribute('aria-busy');
        confirmBtn.disabled = false;
        confirmBtn.innerHTML = 'Confirmer la commande';
      }
    });

    // mark & initial paint
    if (openBtn) openBtn.dataset.codWired = '1';

    // NEW: start watching the hidden variant id (mobile templates)
    startVariantWatch();

    refreshContent();
  }

  // Wait for COD nodes (mobile often injects later)
  if (!openBtn || !modal || !confirmBtn) {
    const mo = new MutationObserver(() => {
      setDomRefs();
      if (openBtn && modal && confirmBtn) {
        mo.disconnect();
        wireListenersOnce();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } else {
    wireListenersOnce();
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // Upsell modal & Final summary (unchanged except for small guards)
  // ─────────────────────────────────────────────────────────────────────────────
  function showUpsellModal(initialItems, customer, shippingFee, redirectUrl) {
    const DISCOUNT_RATE = 0.15;
    const basePrice   = parseFloat(initialItems[0].original_price || initialItems[0].price);
    const upsellPrice = (basePrice * (1 - DISCOUNT_RATE)).toFixed(2);

    const overlay = document.createElement('div');
    overlay.id = 'upsell-overlay';
    overlay.innerHTML = `
      <style>
        #upsell-overlay{position:fixed;inset:0;background:rgba(0,0,0,.6);
          display:flex;align-items:center;justify-content:center;z-index:10000;}
        #upsell-box{background:#fff;border-radius:8px;width:90%;max-width:400px;
          padding:1rem;position:relative;max-height:90vh;overflow-y:auto;font-family:sans-serif;}
        #upsell-close{position:absolute;top:8px;right:8px;background:none;border:none;font-size:1.25rem;cursor:pointer;}
        #upsell-box h2{text-align:center;margin:0 0 .5rem;}
        #upsell-timer{text-align:center;margin-bottom:1rem;font-weight:bold;}
        #upsell-timer strong{color:#e55353;}
        #upsell-img{width:100%;max-height:40vh;object-fit:contain;margin-bottom:1rem;}
        #upsell-variants{display:grid;grid-template-columns:1fr 1fr;gap:.5rem;margin-bottom:1rem;}
        #upsell-variants select{width:100%;padding:.5rem;}
        #upsell-prices{text-align:center;margin-bottom:1rem;}
        #upsell-prices del{color:#888;margin-right:.5rem;}
        #upsell-buttons{display:flex;gap:.5rem;}
        #upsell-buttons button{flex:1;padding:.75rem;border:none;border-radius:4px;font-size:1rem;cursor:pointer;}
        #upsell-accept{background:#28a745;color:#fff;}
        #upsell-decline{background:#ddd;}
      </style>
      <div id="upsell-box">
        <button id="upsell-close">×</button>
        <h2>Offre spéciale – 15 % de réduction</h2>
        <p id="upsell-timer"><strong>00:01:00</strong></p>
        <img id="upsell-img" src="${initialItems[0].imgSrc||''}" alt="">
        <div id="upsell-variants">
          <select id="upsell-size"></select>
          <select id="upsell-color"></select>
        </div>
        <div id="upsell-prices">
          <del>${currencySymbol} ${basePrice.toFixed(2)}</del>
          <strong>${currencySymbol} ${upsellPrice}</strong>
        </div>
        <div id="upsell-buttons">
          <button id="upsell-accept">Oui, j’accepte</button>
          <button id="upsell-decline">Non merci</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);

    // Timer
    let timeLeft = 60;
    const timerEl = overlay.querySelector('#upsell-timer strong');
    const timerId = setInterval(() => {
      timeLeft--;
      const mm = String(Math.floor(timeLeft/60)).padStart(2,'0');
      const ss = String(timeLeft%60).padStart(2,'0');
      timerEl.textContent = `${mm}:${ss}`;
      if (timeLeft <= 0) {
        clearInterval(timerId);
        overlay.querySelector('#upsell-decline').click();
      }
    }, 1000);

    const variants = window.productVariants || productVariants || [];
    const sizeSel  = overlay.querySelector('#upsell-size');
    const colorSel = overlay.querySelector('#upsell-color');
    [...new Set(variants.map(v => v.option1))].forEach(s => {
      sizeSel.innerHTML += `<option value="${s}">${s}</option>`;
    });
    function updateColors() {
      const opts = variants.filter(v => v.option1 === sizeSel.value);
      colorSel.innerHTML = opts.map(v => `<option value="${v.option2}">${v.option2}</option>`).join('');
      updateImage();
    }
    function updateImage() {
      const chosen = variants.find(v => v.option1===sizeSel.value && v.option2===colorSel.value);
      overlay.querySelector('#upsell-img').src = chosen?.featured_image?.src || initialItems[0].imgSrc || '';
    }
    sizeSel.onchange  = updateColors;
    colorSel.onchange = updateImage;
    updateColors();

    const decline = () => {
      clearInterval(timerId);
      document.body.removeChild(overlay);
      showFinalSummaryModal(
        initialItems, [], customer, shippingFee,
        discountInput?.value.trim() || '',
        parseFloat(discountAmt?.textContent || 0) || 0,
        redirectUrl
      );
    };
    overlay.querySelector('#upsell-close').onclick =
    overlay.querySelector('#upsell-decline').onclick = decline;

    overlay.querySelector('#upsell-accept').onclick = () => {
      clearInterval(timerId);
      const chosen = variants.find(v => v.option1===sizeSel.value && v.option2===colorSel.value);
      if (!chosen) { alert('Variant introuvable, réessayez.'); return; }

      const upsellItem = {
        variant_id:    chosen.id,
        quantity:      1,
        price:         Number(upsellPrice),
        title:         productTitle,
        variant_title: `${chosen.option1} / ${chosen.option2}`,
        imgSrc:        chosen.featured_image?.src || ''
      };

      const shipEl = document.querySelector('input[name="cod-shipping"]:checked');
      const shippingTitle = shipEl?.dataset.title || 'Livraison';

      const upsellPayload = {
        clientId,
        ...customer,
        deliveryTitle: shippingTitle,
        deliveryTag: 'Upsell',
        line_items: [ upsellItem ],
        shippingFee: 0,
        subtotal: Number(upsellPrice),
        total:    Number(upsellPrice),
        tags: 'Upsell'
      };

      sessionStorage.setItem('upsellClientId', clientId);

      fetch(WEB_APP_URL, {
        method: 'POST',
        headers: { 'Content-Type':'text/plain' },
        body: JSON.stringify(upsellPayload)
      })
      .then(r => r.json())
      .catch(err => console.error('Upsell error:', err))
      .finally(() => {
        document.body.removeChild(overlay);
        showFinalSummaryModal(
          initialItems, [upsellItem], customer, shippingFee,
          discountInput?.value.trim() || '',
          parseFloat(discountAmt?.textContent || 0) || 0,
          window.location.origin
        );
      });
    };
  }

  function showFinalSummaryModal(initialItems, upsellItems, customer, shippingFee, discountCode, discountAmount, redirectUrl) {
    shippingFee    = Number(shippingFee)    || 0;
    discountAmount = Number(discountAmount) || 0;

    const allItems = initialItems.concat(upsellItems);
    if (!allItems.length) { window.location.href = '/'; return; }

    // Keep the completed checkout behind the confirmation recap. We do not
    // close it yet because closeModal() restores floating chat widgets.
    const checkoutModal = document.getElementById('cod-modal');
    if (checkoutModal) checkoutModal.style.setProperty('visibility', 'hidden', 'important');
    startFloatingWidgetSuppression();

    const money = (n) => `${currencySymbol}${Math.abs(Number(n) || 0).toFixed(2)}`;
    const escapeHtml = (value) => String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

    const rawSub = allItems.reduce((s, i) => s + (parseFloat(i.price) || 0) * (i.quantity || 1), 0);
    const discountApplied = discountAmount < 0 ? Math.abs(discountAmount) : 0;
    const totalNet = Math.max(0, rawSub - discountApplied + shippingFee);

    const itemsHtml = allItems.map(item => {
      const qty = Number(item.quantity) || 1;
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div style="margin-top:4px;color:#777;font-size:13px;line-height:1.35;">${escapeHtml(item.variant_title)}</div>`
        : '';
      const qtyHtml = qty > 1
        ? `<span style="display:inline-block;margin-top:6px;padding:3px 8px;border-radius:999px;background:#f4eee9;color:#6b625d;font-size:12px;font-weight:700;">Qté ${qty}</span>`
        : '';

      return `
        <div style="display:grid;grid-template-columns:58px minmax(0,1fr);gap:12px;align-items:center;padding:12px 0;border-bottom:1px solid #eee7e3;">
          <img src="${escapeHtml(item.imgSrc || '')}" alt="" width="58" height="72" style="width:58px;height:72px;object-fit:cover;border-radius:9px;border:1px solid #eee5df;background:#faf8f6;">
          <div style="min-width:0;">
            <div style="font-size:14px;font-weight:700;color:#313131;line-height:1.35;overflow-wrap:anywhere;">${escapeHtml(item.title || 'Article')}</div>
            ${variant}
            ${qtyHtml}
          </div>
        </div>`;
    }).join('');

    const overlay = document.createElement('div');
    overlay.id = 'cod-final-summary-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Commande confirmée');
    overlay.style.cssText = [
      'position:fixed', 'inset:0', 'background:rgba(31,28,26,.62)',
      'backdrop-filter:blur(5px)', '-webkit-backdrop-filter:blur(5px)',
      'display:flex', 'align-items:center', 'justify-content:center',
      'padding:18px', 'z-index:2147483647', 'box-sizing:border-box'
    ].join(';');

    const recapModal = document.createElement('div');
    recapModal.style.cssText = [
      'background:#fff', 'border-radius:18px', 'width:min(92vw,440px)',
      'max-height:88dvh', 'overflow-y:auto', 'overscroll-behavior:contain',
      'box-shadow:0 22px 60px rgba(0,0,0,.25)',
      'font-family:inherit', 'color:#333', 'box-sizing:border-box'
    ].join(';');

    recapModal.innerHTML = `
      <div style="padding:24px 22px 20px;">
        <div style="display:flex;justify-content:center;margin-bottom:13px;">
          <div style="width:50px;height:50px;border-radius:50%;background:#eaf7ef;color:#2f9a5a;display:flex;align-items:center;justify-content:center;font-size:28px;font-weight:900;line-height:1;">✓</div>
        </div>
        <h2 style="margin:0;text-align:center;font-size:23px;line-height:1.25;color:#262626;">Commande confirmée</h2>
        <p style="margin:7px 0 20px;text-align:center;color:#737373;font-size:14px;line-height:1.45;">Merci ! Votre commande a bien été enregistrée.</p>

        <div style="font-size:13px;font-weight:800;letter-spacing:.02em;color:#555;margin-bottom:2px;">Récapitulatif de commande</div>
        <div>${itemsHtml}</div>

        <div style="margin-top:16px;padding:15px 16px;background:#faf8f6;border:1px solid #eee6e1;border-radius:12px;">
          <div style="display:flex;justify-content:space-between;gap:16px;margin-bottom:10px;font-size:14px;color:#666;"><span>Sous-total</span><strong style="color:#444;">${money(rawSub)}</strong></div>
          ${discountApplied > 0 ? `<div style="display:flex;justify-content:space-between;gap:16px;margin-bottom:10px;font-size:14px;color:#bd3434;"><span>Réduction${discountCode ? ` (${escapeHtml(discountCode)})` : ''}</span><strong>− ${money(discountApplied)}</strong></div>` : ''}
          <div style="display:flex;justify-content:space-between;gap:16px;margin-bottom:12px;font-size:14px;color:#666;"><span>Livraison</span><strong style="color:#444;">${money(shippingFee)}</strong></div>
          <div style="height:1px;background:#e3ddd9;margin:0 0 12px;"></div>
          <div style="display:flex;justify-content:space-between;gap:16px;align-items:center;font-size:17px;font-weight:900;color:#34895d;"><span>Total</span><span>${money(totalNet)}</span></div>
        </div>

        <button id="final-ok-btn" type="button" style="width:100%;margin-top:18px;padding:14px 18px;background:#2da354;color:#fff;border:0;border-radius:10px;cursor:pointer;font:inherit;font-size:16px;font-weight:800;box-shadow:0 6px 15px rgba(45,163,84,.18);">Terminer</button>
      </div>`;

    overlay.appendChild(recapModal);
    document.body.appendChild(overlay);

    recapModal.querySelector('#final-ok-btn')?.addEventListener('click', () => {
      overlay.remove();
      if (checkoutModal) checkoutModal.style.removeProperty('visibility');
      closeModal();
      window.location.href = redirectUrl || '/';
    });
  }

}); // DOMContentLoaded
